export const COMPANY = {
  name: {
    short: 'Benefit Systems SA',
  },
  address: {
    street: 'address.street',
    zip: 'address.zip',
    city: 'address.city',
    text: 'address.text',
  },
  identificationNumbers:
    {
      nip: {
        label: 'identificationNumbers.nip.label',
        value: 'identificationNumbers.nip.value',
      },
      krs: {
        label: 'identificationNumbers.krs.label',
        value: 'identificationNumbers.krs.value',
        text: 'identificationNumbers.krs.text',
      },
      regon: {
        label: 'identificationNumbers.regon.label',
        value: 'identificationNumbers.regon.value',
      },
      bdo: {
        label: 'identificationNumbers.bdo.label',
        value: 'identificationNumbers.bdo.value',
      },
    },
  shareCapital: {
    label: 'shareCapital.label',
    value: 'shareCapital.value',
    text: 'shareCapital.text',
    currency: 'shareCapital.currency',
  },
  infoline: {
    phone: [
      {
        text: 'infoLine.phone[0].text',
        value: 'infoLine.phone[0].value',
      },
    ],
    email: [
      {
        text: 'infoLine.email[0].text',
        value: 'infoLine.email[0].value',
      },
    ],
    hours: [
      {
        text: 'infoLine.hours[0].text',
        value: 'infoLine.hours[0].value',
      },
    ],
  },
}
